import {ReviewsCore} from "./ReviewsCore";
import {ParametersValidation} from "../../core/errors/ParametersValidation";
import {Pagination} from "../../core/Pagination";
import Swiper from 'swiper';

const MODES = {
    SLIDER: 'slider',
    LIST: 'list'
};

export class ReviewsClient {

    /**
     * ReviewsClient constructor
     * @param selector
     * @param url
     * @param params
     */
    constructor({ selector, url, ...params }) {
        ParametersValidation.checkRequired({ selector, url });
        this.Core = new ReviewsCore({ url });
        this.el = document.getElementById(selector);
        this.el.classList.add('widget_reviews');
        this.type = params.type;
        this.code = params.code;
        this.mode = params.mode || MODES.LIST;
        this.perPage = params.perPage || (() => {
            switch (this.mode) {
                case MODES.SLIDER: return 1;
                case MODES.LIST: return 5;
            }
        })();
        this.slideIndex = 0;
        this.lang = params.lang || null;
        this.validateParameters();
    }

    async init() {
        // Appel et construction du conteneur de la vue
        const { count, view } = await this.Core.getView({
            type: this.type,
            code: this.code,
            mode: this.mode,
            lang: this.lang
        });

        this.el.innerHTML = view;
        this.pageContainer = this.el.querySelector('.page-container');

        // Initialisation du mode de vue
        switch (this.mode) {
            case MODES.SLIDER: return this.initSlider();
            case MODES.LIST: return this.initList({ count });
        }
    }

    async loadPage(index) {
        return await this.Core.getPage({
            index,
            perPage: this.perPage,
            code: this.code,
            lang: this.lang
        });
    }

    validateParameters() {
        if (this.type && this.code) {
            console.error('[Widget Reviews] : Type prestataire et code renseignés');
        }
    }

    initList({ count }) {
        this.pagination = new Pagination({
            el: this.el.querySelector('#pagination'),
            perPage: this.perPage,
            count,
            onIndexChange: async index => {
                const { view } = await this.loadPage(index);
                this.pageContainer.innerHTML = view;
            }
        });
        this.pagination.init();
    }

    async initSlider() {
        this.slider = new Swiper(this.el.querySelector('.swiper-container'), {
            direction: 'horizontal',
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
            },
            navigation: {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
            },
            effect: 'slide',
            speed: 500
        })

        const appendPage = async () => {
            this.slideIndex++;
            const {view} = await this.loadPage(this.slideIndex);
            this.slider.appendSlide(view);
        };
        for (let i = 0; i < 3; i++) appendPage();
        this.slider.on('slideNextTransitionStart', appendPage);
    }
}